import { Hero } from '@/components/organisms/Admin/Home/Hero'
import { List } from '@/components/organisms/Admin/Home/List'
import { Matriculate } from '@/components/organisms/Admin/Home/Matriculate'
import { Onboarding } from '@/components/organisms/Admin/Home/Onboarding'

export function HomePage() {
	return (
		<div className='flex flex-col w-full relative z-10 overflow-clip'>
			<Hero />
			<Onboarding />
			<Matriculate />
			<List />
		</div>
	)
}
